import { Query } from '../../../_base/actionBus/Query';

export class GetDisabledAmenities extends Query<number[]> {}
